import { ManageFeed } from 'components/UI/Modal/ManageFeed/ManageFeed'
import { useModalContext } from 'context/modalContext'

import styles from './ManageFeedButton.module.scss'

interface ManageFeedButtonProps {
    onClick?: () => any
    onApply?: (id: string) => void
    chosenListId?: string
}

const ManageFeedButton = ({ onApply, chosenListId }: ManageFeedButtonProps) => {
    const modalData = useModalContext()
    const openManageFeedModal = () => {
        modalData.addModal(
            'Manage Feed',
            <ManageFeed onApply={onApply} chosenListId={chosenListId} />,
            false,
            true 
        )
    }

    return (
        <button
            className={styles.manageFeedButton}
            onClick={() => {
                openManageFeedModal()
            }}
        >
            +
        </button>
    )
}

export default ManageFeedButton
